import {
  useMutation,
  // useQuery,
} from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { getCode, login } from "../requests/auth";
import { AuthError, GetCodeRequest, LoginRequest } from "../types/auth";
import { User } from "../types/user";

// export const useGetSymbols = (): UseQueryResult<Symbol[], AxiosError> =>
//   useQuery(['symbols'], symbols);

export const useGetCode = () =>
  useMutation<AxiosResponse, AuthError, GetCodeRequest, unknown>(getCode);

export const useLogin = () =>
  useMutation<User, AuthError, LoginRequest, unknown>(login);

// export const useRegister = (): UseMutationResult | any =>
//   useMutation<AxiosResponse, AxiosError, User, () => unknown>(register);
